import { CommitmentsCommandsService_commitmentCommandsServiceGetEntities } from '@festina/life-general-types/life/hooks/CommitmentsCommandsService_commitmentCommandsServiceGetEntities'

export const useFetchCommitmentCommandsNoSuspense =
  CommitmentsCommandsService_commitmentCommandsServiceGetEntities.useQuery
